export const SET_CONTRIES_COSENSUS = "SET_CONTRIES_COSENSUS";
export const SET_DATA_CONSENSUS = "SET_DATA_CONSENSUS";
export const SET_DATA_CONSENSUS_RESULT = "SET_DATA_CONSENSUS_RESULT";
export const SET_DATA_FE_FORECAST = "SET_DATA_FE_FORECAST";
export const SET_DATA_LAST_TRIMESTER = "SET_DATA_LAST_TRIMESTER";
export const SET_URL_EXPORT = "SET_URL_EXPORT";
export const SET_BACKTESTING = "SET_BACKTESTING";
export const SET_BACKTESTING_DEVIATION = "SET_BACKTESTING_DEVIATION";
export const SET_BACKTESTING_DEVIATION_ML = "SET_BACKTESTING_DEVIATION_ML";
